<!-- 
HealthPresentModal.vue
功能：健康禮已申請名單開窗
作者：i9400538 陳博承
完成：2021-01-04
-->
<template>
  <div id="health-present-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 800px;">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="col-12 pl-0">
            <h3 class="modal-title text-center">國泰一家人家庭成員名單</h3>
          </div>
        </div>
        <div class="modal-body" :class="{'section-loading': isLoading}">
          <div class="hpm-subtitle">
            1. 查看VIP保戶之國泰一家人家庭成員名單。
            <br/>2. 如需新增或異動家庭成員名單，請透過紙本或線上申請。
          </div>
          <table class="table hpm-table">
            <thead>
              <tr>
                <th class="text-center" rowspan="2" width="25%">姓名</th>
                <th class="text-center" rowspan="2" width="25%">親屬關係</th>
                <th class="text-center" colspan="2" width="60%">結婚生子禮申請</th>
              </tr>
              <tr>
                <th class="text-center" width="25%">申請類型</th>
                <th class="text-center" width="25%">申請日期</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(row, i) in presentData" :key="`row-data-${i}`">
                <td class="text-center">
                  <Tooltip :position="'top'" :name="row.fam_name">{{row.fam_name | getMaskName}}</Tooltip>
                </td>
                <td
                  class="text-center"
                >{{row.fam_relation ? row.fam_relation : row.relation | getRelationText}}</td>
                <td class="text-center">{{row.qualification}}</td>
                <!-- <td class="text-center">{{row.present}}</td> -->
                <td class="text-center">
                  <span v-if="row.apply_time">{{row.apply_time | dateFormat}}</span>
                  <span v-else class="text-red"></span>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <div class="text-center hpm-share">
            <label class="link-text">★國泰一家人活動網頁連結分享★</label>
            <div class="board-body">
              <div class="list video" style="padding:0px 0px">
                <div class="item" style="padding:0px 0px">
                  <div class="content">
                    <div class="action">
                      <button
                        type="button"
                        class="btn btn-default btn-sm"
                        @click="copy(mmlUrl)"
                      >複製連結</button>
                      <i class="icon-line" style="cursor:pointer;" @click="encodeLink(mmlUrl)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <input type="text" style="position:absolute;left:-10000px;top:-10000px" id="copyText" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCathayFamilyPresent } from "@/service";
import Tooltip from "@/desktop/components/ToolTip";
import { mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
export default {
  name: "HealthPresentModal",
  mixins: [commonMixin],
  components: { Tooltip },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    csid: {
      type: String,
      default: ""
    },
    csname: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === "box";
    }
  },
  watch: {
    open: function(val) {
      if (val) {
        this.init();
      }
    }
  },
  filters: {
    //轉換親屬關係
    getRelationText: function(val) {
      let text = "";
      if (!val || !val.trim()) {
        return text;
      }
      if (val == "0") {
        text = "配偶";
      } else if (val == "1") {
        text = "父母";
      } else if (val == "2") {
        text = "子女";
      } else if (val == "8") {
        text = "戶長";
      } else if (val == "9") {
        text = "其他";
      }
      return text;
    }
  },
  data() {
    return {
      isLoading: false,
      presentData: [],
      mmlUrl: "國泰一家人對待家人與您同等尊榮，家庭成員共享部分權益內容，點選網址了解更多! https://cathaylife.tw/koYnxy3"
    };
  },
  methods: {
    //判斷是line還是FB
    encodeLink(link) {
      if (this.isBox) {
        this.boxCathayShareLink(link);
      } else {
        let str = encodeURI(link);
        let url = `http://line.naver.jp/R/msg/text/?${str}`;
        window.open(url);
      }
    },
    //複製連結
    copy(url) {
      if (this.isBox) {
        this.boxCathayShareLink(url);
      } else {
        const copyText = document.getElementById("copyText");
        copyText.value = url;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        if (document.execCommand("cut")) {
          this.$toast.info({ title: "連結已複製" });
        } else {
          console.error("複製失敗");
        }
      }
    },
    init() {
      this.presentData = [];
      if (this.csid) {
        this.isLoading = true;
        getCathayFamilyPresent(
          this.$store.state.userInfo.id,
          this.csid,
          this.csname
        ).then(result => {
          this.isLoading = false;
          if (
            result.header &&
            result.header.status === "200" &&
            result.body.result &&
            result.body.result.length
          ) {
            this.presentData = result.body.result || [];
            this.registerHanlink(); // for hard word
          } else {
            this.presentData = [];
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-header {
  background: transparent !important;
  border-bottom: 0;
  padding: 20px 40px !important;
}

.modal-title {
  color: #657c54 !important;
}

.modal-body {
  min-height: 400px !important;
}

.hpm-subtitle {
  margin-top: -20px;
  margin-bottom: 10px;
  color: #658F49;
  line-height: 1.6;
  font-size: 20px;
  font-weight: 600;
}

.hpm-table,
.hpm-table th,
.hpm-table td,
.hpm-table tr {
  border-color: #7f8978 !important;
}

.hpm-table {
  border: 1px solid #7f8978 !important;
}

.hpm-table thead th {
  background: #c5e0b4 !important;
  color: #466532 !important;
  border: 1px solid #7f8978 !important;
  vertical-align: middle;
  font-size: 18px;
  font-weight: 600;
}

.hpm-table tbody td {
  border: 1px solid #7f8978 !important;
}

.hpm-share {
  margin-top: 5px;
}

.link-text {
  font-size: 20px;
  font-weight: 600;
}
</style>